export const PaymentLoading = () => (
  <div className={"cashier-inner-container deposit-container method loading"}>
	<div className={"title loading-text"}></div>
	<div className={"chooseMethod"}>
	  <div className={"wrapper"}>
		{[0, 1, 2].map((i) => (
		  <div className="col-12 methodItem" key={i}>
			<div className="payment-select-wrapper">
			  <div className="payment-icon loading-text"></div>
			  <div className="payment-selection">
				<div className="selection-wrapper">
				  <div className="">
					<p className="payment-select-name"></p>
				  </div>
				</div>
				<div className="description">
				  <div className={"loading-text"}></div>
				  <div className={"loading-text"}></div>
				  <div className={"loading-text"}></div>
				</div>
			  </div>
			  <div className="btnWrapper"></div>
			</div>
		  </div>
		))}
	  </div>
	</div>
  </div>
);